import React, { useState, useEffect } from 'react'
import { Container, Typography, Grid, Card, CardMedia, CardContent, CardActions, Button } from '@material-ui/core'
import { useNavigate } from 'react-router-dom'

import TopNavigation from "./TopNavigation"
import Footer from "./Footer"

import { database } from '../lib/firebase'
import { ref, onValue } from 'firebase/database'

const Home = () => {
  const [entriesList, setEntriesList] = useState({})
  const navigate = useNavigate()

  useEffect(() => {
    const entriesRef = ref(database, '/entries')
    const unsubscribe = onValue(entriesRef, (snapshot) => {
      const data = snapshot.val()
      setEntriesList(data || {})
    })

    return () => unsubscribe()
  }, [])

  return (
    <div>
      <TopNavigation />
      <br />
      <Container>
        <Typography variant="h4" sx={{ fontWeight: "bold", color: "#081d4b" }}>
          Notas
        </Typography>
        <br />
        <Grid container spacing={4}>
          {Object.keys(entriesList).map((key) => {
            const entry = entriesList[key]
            const { title, picture, content } = entry

            return (
              <Grid item xs={12} sm={6} md={4} lg={3} key={key}>
                <Card>
                  <iframe
                    width="100%"
                    height="100%"
                    frameBorder="0"
                    src={picture}
                    title="Convocatorias Públicas del Gobierno Boliviano"
                    style={{ border: 'none', marginTop: '20px', display: 'block' }}
                  ></iframe>
                  <CardContent>
                    <Typography gutterBottom variant="h6">
                      {title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {content.length > 150 ? content.substring(50, 150) + '...' : content}
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <Button size="small" color="primary" onClick={() => navigate(`/entry/${key}`)}>
                      Leer mas
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            )
          })}
        </Grid>
      </Container>
      <br />
      <main style={{ minHeight: '60px' }}>
        {/* separador */}
      </main>
      <Footer />
    </div>
  )
}

export default Home